import React, { useCallback, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import ProgressPollingQuery, {
	type mainEditFormSubmitStatus_progressPollingQuery,
} from '@atlassian/jira-relay/src/__generated__/mainEditFormSubmitStatus_progressPollingQuery.graphql';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useFormSubmitProgressData } from '../../../controllers/use-form-submit-state/main.tsx';
import { useResetFormSubmissionState } from '../../../controllers/use-form-submit-state/utils.tsx';
import { ProgressPolling } from './main.tsx';

export const EditFormSubmitStatusProgressPolling = () => {
	const cloudId = useCloudId();
	const { taskId } = useFormSubmitProgressData() || {};
	const reset = useResetFormSubmissionState();
	const [queryReference, fetchFormStatus, disposeQuery] =
		useQueryLoader<mainEditFormSubmitStatus_progressPollingQuery>(ProgressPollingQuery);

	const refetch = useCallback(
		(id: string) => {
			fetchFormStatus(
				{
					taskId: id,
					cloudId,
				},
				{
					fetchPolicy: 'network-only',
				},
			);
		},
		[cloudId, fetchFormStatus],
	);

	useEffect(() => reset, [reset]);

	useEffect(() => {
		if (taskId) {
			refetch(taskId);
		}
	}, [refetch, taskId]);

	useEffect(() => {
		if (!taskId) {
			disposeQuery();
		}
	}, [disposeQuery, taskId]);

	return queryReference && taskId ? (
		<Placeholder name="bulk-operations.core.form.submit-status.progress-polling" fallback={null}>
			<ProgressPolling taskId={taskId} queryReference={queryReference} refetch={refetch} />
		</Placeholder>
	) : null;
};
